import { Box } from '@factorialco/deprecated-design-system'

import { CustomizationProps } from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import { PermissionsProps } from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

import FromField from './FromField'
import ToField from './ToField'

interface Props extends PermissionsProps, CustomizationProps {
  loading: boolean
}

const Trip = (props: Props) => {
  return (
    <Box gap="s16">
      <FromField {...props} fieldIdentifier="from" isFieldMandatory />
      <ToField {...props} fieldIdentifier="to" isFieldMandatory />
    </Box>
  )
}

export default Trip
